import { SELL_API } from './axiosInstance';

export interface LeadMetadataOption {
    value: string;
    label: string;
}

export interface LeadMetadataResponse {
    businessTypes: LeadMetadataOption[];
    servicesOfInterest: LeadMetadataOption[];
}

export const submitLeadCapture = async (sessionId: string, payload: Record<string, unknown>) => {
    const response = await SELL_API.post(`/sessions/${sessionId}/leads`, payload);
    return response.data;
};
